import React, { useState, useEffect } from 'react'
import { getCompany } from '../../../services/request.service';
import { getUserApprover } from '../../../services/auth.service';
import { useForm } from 'react-hook-form';

const Step1 = ({ page, setPage, formData, setFormData }) => {

  const [company, setCompany] = useState([])
  const [userApprover, setUserApprover] = useState([])
  const {register, handleSubmit, formState: {errors} } = useForm();

  let date = new Date()
  let day  = date.getDate()
  let month = date.getMonth() + 1;
  if(day < 10){
    day = `0${day}`
  }
  if(month < 10){
    month = `0${month}`
  }
  let year = date.getFullYear()

  useEffect(()=>{
    (async () => {
      const data = await getCompany()
      setCompany(data)
      const dataUser = await getUserApprover()
      setUserApprover(dataUser)
    })() 
  },[])

  const onSubmit = () => {
      setPage(page + 1);
  }

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  }
  return (
    <div>
      <form className="row g-3" onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-3 row">
          <label htmlFor="initialDate" className="col-sm-4 col-form-label">
            Fecha ingreso a planta
          </label>
          <div className="col-sm-8">
            <input
              name="initialDate"
              type="date"
              className="form-control"
              min={`${year}-${month}-${day}`}
              {...register("initialDate", {
                required: "Seleccione una fecha de ingreso",
              })}
              value={formData.initialDate}
              onChange={handleInputChange}
            />
            {errors?.initialDate && (
              <span className="danger">{errors.initialDate.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="finalDate" className="col-sm-4 col-form-label">
            Fecha salida de planta
          </label>
          <div className="col-sm-8">
            <input
              name="finalDate"
              type="date"
              className="form-control"
              min={formData.initialDate}
              {...register("finalDate", {
                required: "Seleccione una fecha de salida",
              })}
              value={formData.finalDate}
              onChange={handleInputChange}
            />
            {errors?.finalDate && (
              <span className="danger">{errors.finalDate.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="companyId" className="col-sm-4 col-form-label">
            Empresa a visitar
          </label>
          <div className="col-sm-8">
            <select
              name="companyId"
              placeholder={"Seleccione una empresa"}
              className="form-select"
              {...register("companyId", { required: "Seleccione una empresa" })}
              onChange={handleInputChange}
            >
              <option
                label={"Seleccione una empresa"}
                defaultValue={"Seleccione una empresa"}
              />
              {company.map((option, key) => (
                <option key={key} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select>
            {errors?.companyId && (
              <span className="danger">{errors.companyId.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="subject" className="col-sm-4 col-form-label">
            Asunto
          </label>
          <div className="col-sm-8">
            <input
              name="subject"
              type="text"
              className="form-control"
              placeholder="Asunto..."
              {...register("subject", {
                required: "Este campo es requerido",
              })}
              value={formData.subject}
              onChange={handleInputChange}
            />
            {errors?.subject && (
              <span className="danger">{errors.subject.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="userIdApprover" className="col-sm-4 col-form-label">
            Funcionario aprobador
          </label>
          <div className="col-sm-8">
            <select
              name="userIdApprover"
              placeholder={"Seleccione un funcionario"}
              className="form-select"
              {...register("userIdApprover", {
                required: "Seleccione un funcionario aprobador",
              })}
              onChange={handleInputChange}
            >
              <option
                label="Seleccione un funcionario"
                defaultValue={"Seleccione una empresa"}
              />
              {userApprover.map((option, key) => (
                <option key={key} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select>
            {errors?.userIdApprover && (
              <span className="danger">{errors.userIdApprover.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label
            htmlFor="requestDescription"
            className="col-sm-8 col-form-label"
          >
            Descripción de la solicitud
          </label>
          <div className="col-sm-12">
            <textarea
              name="requestDescription"
              className="form-control"
              rows="3"
              placeholder="Descripccion de la solicitud..."
              {...register("requestDescription", {
                required: "Describa la solicitud",
              })}
              value={formData.requestDescription}
              onChange={handleInputChange}
            ></textarea>
            {errors?.requestDescription && (
              <span className="danger">
                {errors.requestDescription.message}
              </span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <button type="submit" className="btn btn-success col-sm-12 btn-sm">
            Siguente
          </button>
        </div>
      </form>
    </div>
  );
}

export default Step1;
